import { Injectable } from '@angular/core';
import {HttpClientService} from './http-client.service';
import {AppConfigService} from './app-config.service';
import {Customer} from './app-models/models';
import {Headers} from '@angular/http';

@Injectable()
export class CreateCustomerService {

  private apiUrl = AppConfigService.settings.apiUrl + 'customers/';

  constructor(private http: HttpClientService) {
  }

  getData(): Promise<any> {
    return this.http.get(this.apiUrl + 'getoptions')
      .toPromise()
      .then(response => response.json() as any)
      .catch(this.handleError);
  }

  getDataFromOrder(orderId: string): Promise<any> {
    return this.http.get(this.apiUrl + 'getfromorder?orderId=' + orderId)
      .toPromise()
      .then(response => response.json() as any)
      .catch(this.handleError);
  }

  createCustomer(data: Customer): Promise<Customer> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http.post(this.apiUrl + 'create', JSON.stringify(data), headers)
      .toPromise()
      .then(response => response.json() as Customer)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/create-customer.service.ts